/**
 * DSA folder roots for the patient/lesion hierarchy (both under mISIC).
 * Toggle between these in the header collection dropdown.
 */
export const RCM_COLLECTIONS = [
  {
    id: 'isic',
    label: 'ISIC only',
    folderId:
      process.env.REACT_APP_RCM_ISIC_CLEAN_FOLDER_ID ||
      '6a289203b7dea025ea2e1a07',
  },
  {
    id: 'full',
    label: 'Full RCM',
    folderId:
      process.env.REACT_APP_RCM_BY_PATIENT_FOLDER_ID ||
      '6a286373b7dea025ea2e169b',
  },
];

export const DEFAULT_COLLECTION_ID = 'isic';

export function getDefaultCollectionId() {
  const envCollection = process.env.REACT_APP_DEFAULT_COLLECTION;
  if (envCollection) {
    const match = RCM_COLLECTIONS.find((c) => c.id === envCollection);
    if (match) return match.id;
  }
  return DEFAULT_COLLECTION_ID;
}

export function getCollectionById(collectionId) {
  return (
    RCM_COLLECTIONS.find((c) => c.id === collectionId) ?? RCM_COLLECTIONS[0]
  );
}
